import {Component, EventEmitter, Inject, Input, Output} from 'ng-metadata/core';
//your imports go here
import {SmoothScrollUtil} from '../../../../nddUtils/smoothScrollUtil.service';
import {STATE_NAMES} from '../../../../primoExplore/primoExploreStates.module';
import {getResultsBulkSize} from '../../../../appConfig/appConfigForward';
import {ChangeLangService} from '../../../../infra/lang/changeLang.service';
import {MediaQueries} from '../../../../infra/mediaQueries.service';
import {isBrowserIE} from '../../../../infra/browserSniffer';
import {isBrowserSafari} from '../../../../infra/browserSniffer';
import {PageNavMenuService} from './pageNavMenu.service';

const clone= require('lodash/clone');
const range= require('lodash/range');
const tail= require('lodash/tail');
const NUM_OF_PAGE_LINKS= 5;

@Component({
selector: 'prm-page-nav-menu',
templateUrl: 'components/search/searchResult/searchResultList/pageNavMenu/page-nav-menu.html',
})


export class PrmPageNavMenu{
    @Input() currentPage: number;
    @Input() numOfResults: number;
    @Input() numOfLoadedPages: number;
    @Input() showComponents: {};
    @Input() mode: string;
    @Input() facetToLeft: boolean;
    //those fields are functions(predicats)  , deteminate if  next/prev buttons should display..
    @Input() showNextButtonPredicate= ()=>{return false;};
    @Input() showPrevButtonPredicate= ()=>{return false;};
    
    @Output() loadNextResultsEvent = new EventEmitter<void>();
    @Output() loadPrevResultsEvent = new EventEmitter<void>();
    
    private PAGE_SIZE: number;
    private isOpen: boolean= false;
    private selectedMode= 'md-fling';
    private expandDirection = 'right';
    private availablePageElements: Array<Element>; 
    private availablePages: Array<number>= [];
    private SEARCH_STATE= STATE_NAMES.SEARCH;
    private closeTimeout: ng.IPromise<void>;
    private startPage: number;
    private isClickEvent: boolean;
    
    private loadMoreResultText: string;
    private goToNextPageText: string;
    
    constructor(private smoothScrollUtil: SmoothScrollUtil,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$element') private $element,
                @Inject('$state') private $state: ng.ui.IStateService,
                private changeLangService: ChangeLangService,
                private mediaQueries: MediaQueries,
                private pageNavMenuService: PageNavMenuService) {
        $translate(['nui.brief.results.loadMore', 'link.title.results.next']).then((translations)=>{
                this.loadMoreResultText= translations['nui.brief.results.loadMore'];
                this.goToNextPageText= translations['link.title.results.next'];
            });
    }
    
    ngOnInit(){
        this.PAGE_SIZE = getResultsBulkSize();
        this.initPageList();
        this.$scope.$watch(()=>this.isOpen, (newVal,oldVal)=>{
                this.unfocusActionButtons(); 
            });
    }
    
    private initPageList(){
        let offset= this.$stateParams['offset'] ? this.$stateParams['offset'] : 0;
        this.startPage= Math.floor(offset/ this.PAGE_SIZE) + 1;
        let loadedPageNum= this.startPage + this.numOfLoadedPages -1;
        let numOfSidePages= Math.floor(NUM_OF_PAGE_LINKS/ 2);
        let pagesBeforeStartPage= Math.min(loadedPageNum - numOfSidePages + 1, numOfSidePages);
        let pagesAfterStartPage= numOfSidePages + (numOfSidePages- pagesBeforeStartPage);
        pagesBeforeStartPage+= numOfSidePages - Math.min(this.maxPage-loadedPageNum, numOfSidePages);
        this.availablePages= range(Math.max(loadedPageNum- pagesBeforeStartPage, 1), Math.min(loadedPageNum+ pagesAfterStartPage, this.maxPage) +1);
    }
    
    //this function places tabindex=-1 on all fab-action buttons so that they aren't focused when md-fab-speed-dial is closed
    private unfocusActionButtons(){
        if(!this.isOpen && this.$element){
            let actionButtons: [Element]= this.$element[0].querySelectorAll('md-fab-actions a');
            for(let button of actionButtons){
                button.setAttribute('tabindex', '-1');
            }
        }        
    } 
    
    private getPageList(){
        if (this.facetToLeft) {
            return this.availablePages.slice().reverse();
        }
        return this.availablePages; 
    }
    
    private getNextPage(e){
        e.preventDefault();
        let lastLoadedPage= this.startPage + this.numOfLoadedPages -1;
        if (this.currentPage < lastLoadedPage){
            if (document.querySelector("#searchResultPage"+ (this.currentPage+1))) {
                this.jumpToPage(this.currentPage+1, e);
            } else {
                this.loadNextResultsEvent.emit(null);
            }    
         }
        else{
            this.loadNextResultsEvent.emit(null);
        }
    }
    
    private jumpToPage(pageNum, e){
        this.pageNavMenuService.needToUpdatePivInSafari = false;
        if (this.mode === 'browse'){
            e.preventDefault();
            return;
        }
        if(document.querySelector("#searchResultPage"+ pageNum)){
            e.preventDefault();
            this.smoothScrollUtil.scrollTo('searchResultPage'+pageNum, null, null);
        } 
    }
    
    private updatePivInSafari() {
         this.pageNavMenuService.needToUpdatePivInSafari = isBrowserSafari()  ? true : false; 
    }
    
    private getPageLinkParams(pageNum: number){
        let pageLinkParams=clone(this.$stateParams);
        pageLinkParams.offset= (pageNum-1)*this.PAGE_SIZE;
        pageLinkParams.came_from = "pagination";
        return pageLinkParams;  
    }
    
    private onClickSpeedDial(){
        this.isClickEvent= true;
        // cancel timeouts so they don't fire after the speed dial is opened or closed by a click
        this.$timeout.cancel(this.closeTimeout); 
    }
    
    private onTriggerButtonFocus(e){
        this.isOpen= true;
        //this.$timeout.cancel(this.closeTimeout);
//        if (!this.isClickEvent && !this.isOpen){
//            this.isOpen= true;
//            //e.target.click()
//        }
//        this.isClickEvent= false;
    }
    
    private onActionButtonFocus(){
        this.$timeout.cancel(this.closeTimeout);
    }
    
    private onBlur(){
        this.closeTimeout= this.$timeout(()=>{this.isOpen= false}, 100);
    }
    
    
    private isLastLoadedPage(pageNum: number){
        return pageNum === this.startPage + this.numOfLoadedPages -1;
    }
    
    private isFirstLoadedPage(pageNum: number){
        return pageNum === this.startPage;
    }
    
    private getNextPageButtonText(){
        if (this.isLastLoadedPage(this.currentPage)){
            return this.loadMoreResultText;
        }
        return this.goToNextPageText;
    }
    
    
    private getPageWidgetDirection(){
        let directionStyle= window.getComputedStyle(this.$element[0].children[0]).direction;
        let dir= this.$element.attr('dir');
        if (this.changeLangService.direction === 'rtl' || dir ==='rtl' || directionStyle === 'rtl'){
            return 'left';
        }
        return 'right';
    }

    public throwPrevResultsEvent(){
        this.loadPrevResultsEvent.emit(null);
    }
    
    get maxPage(){
        return Math.ceil(this.numOfResults/this.PAGE_SIZE);
    }

    get stateName(){
        return this.$state.current.name;
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultList/pageNavMenu/pageNavMenu.directive.ts